import React, { useContext, useRef } from 'react';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from "@material-ui/core/MenuItem";
import { DropdownContext } from '../utils/constants';
import Select from '@material-ui/core/Select';

const DropdownValue = (key, value) => {
    return (
        <MenuItem key={key} value={key}>
            {value}
        </MenuItem>
    );
}

export default function SortableDropdownSelect({ dropdownName, dropdown, customSorter, variant, fullWidth, size, labelId, label, controlClass, sort = false, selectClass, ...props }) {
    const { dropdowns } = useContext(DropdownContext);
    const labelRef = useRef();
    const labelWidth = labelRef.current ? labelRef.current.clientWidth : 0

    if (dropdownName) {
        dropdown = dropdowns[dropdownName] || {};
    }

    let dropdownArray = Object.keys(dropdown).map(key => {
        const dropdownValue = dropdown[key];
        return {key, value: dropdownValue};
    });

    if (customSorter) {
        dropdownArray = customSorter(dropdownArray);
    }

    if (sort) {
        dropdownArray = dropdownArray.sort((a, b) => (a.value > b.value) ? 1 : -1)
    }

    return (
        <FormControl
            className={controlClass}
            variant={variant}
            size={size}
            fullWidth={fullWidth}
        >
            <InputLabel ref={labelRef} id={labelId}>{label}</InputLabel>
            <Select
                labelId={labelId}
                labelWidth={labelWidth}
                className={selectClass}
                {...props}
            >
                {dropdownArray.map(item => {
                    return DropdownValue(item.key, item.value);
                })}
            </Select>
        </FormControl>
    );
}
